import { apiPost } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { IExamConfig, IExamConfigSubject } from "./getExamConfigList";

// 시험 설정 생성 요청 인터페이스
export interface ICreateExamConfigRequest {
  id: string;
  subjects: IExamConfigSubject[];
}

// 시험 설정 생성 API 함수
export const apiCreateExamConfig = async (data: ICreateExamConfigRequest) => {
  const response = await apiPost<IExamConfig>("/exam_configs", data);
  return response.data;
};

// 시험 설정 생성 React Query 훅
export const useCreateExamConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiCreateExamConfig,
    onSuccess: () => {
      // 시험 설정 목록 데이터 갱신
      queryClient.invalidateQueries({ queryKey: ["examConfigs"] });
    },
  });
};

export default useCreateExamConfig;
